<template>
  <div class="page-container">
    <!--列表-->
    <el-table
      :data="tenantData"
      style="width: 100%; margin-bottom: 20px"
      row-key="Key"
      border
      size="mini"
      :tree-props="{ children: 'Children' }"
    >
      <el-table-column prop="Code" label="机构/店铺" sortable width="250">
        <template slot-scope="scope">
          <el-form
            label-position="left"
            style="float: right; width: 80%"
            :inline="false"
          >
            <el-form-item label="名称:" style="margin-bottom: 0px">{{
              scope.row.Name
            }}</el-form-item>
            <el-form-item style="margin-bottom: 0px" label="代码:">{{
              scope.row.Code
            }}</el-form-item>
            <el-form-item
              v-if="scope.row.IsShop"
              style="margin-bottom: 0px"
              label="状态:"
            >
              {{ format.tenantStatusFormat(scope.row.Status) }}
            </el-form-item>
            <el-form-item
              v-if="scope.row.IsShop"
              style="margin-bottom: 0px"
              label="扣费:"
            >
              {{ scope.row.PlatChargeRate }}%
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="店铺信息" sortable min-width="200">
        <template slot-scope="scope">
          <el-form label-position="left" :inline="false">
            <el-form-item style="margin-bottom: 0px" label="负责人:">{{
              scope.row.Responser
            }}</el-form-item>
            <el-form-item style="margin-bottom: 0px" label="电话:">{{
              scope.row.Mobile
            }}</el-form-item>
            <el-form-item style="margin-bottom: 0px" label="邮件:">{{
              scope.row.Email
            }}</el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        prop="OpenShopUuid"
        label="授权配置"
        sortable
        min-width="300"
      >
        <template slot-scope="scope">
          <el-form
            v-if="scope.row.IsShop"
            label-position="left"
            :inline="false"
          >
            <el-form-item style="margin-bottom: 0px" label="DeveloperId:">{{
              scope.row.DeveloperId
            }}</el-form-item>
            <el-form-item style="margin-bottom: 0px" label="SignKey:">{{
              scope.row.SignKey
            }}</el-form-item>
             <el-form-item style="margin-bottom: 0px" label="ShopPlatCode:">{{
              scope.row.ShopPlatCode
            }}</el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="Token" label="授权信息" sortable min-width="300">
        <template slot-scope="scope">
          <el-form
            v-if="scope.row.IsShop"
            label-position="left"
            :inline="false"
          >
            <el-form-item style="margin-bottom: 0px" label="Token:">{{
              scope.row.Token
            }}</el-form-item>
            <el-form-item style="margin-bottom: 0px" label="TokenExpire:">{{
              scope.row.TokenExpire
            }}</el-form-item>
            <el-form-item
              style="margin-bottom: 0px"
              label="RefreshToken:"
              >{{ scope.row.RefreshToken }}</el-form-item
            >
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="Description" label="备注" width="100">
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              type="success"
              icon="el-icon-star-on"
              size="small"
              v-if="scope.row.IsShop && scope.row.Status != 10"
              @click="handleAuth(scope.row)"
              >授权</el-button
            >
            <el-button
              v-if="
                scope.row.IsShop &&
                scope.row.Status == 10 &&
                scope.row.LeftRefreshCount > 0
              "
              type="warning"
              icon="el-icon-refresh-left"
              size="small"
              @click="handleRefresh(scope.row)"
              >刷新</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="small"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              v-if="scope.row.Code != 'MJ'"
              icon="el-icon-delete"
              size="small"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
            <el-button
              type="success"
              v-if="!scope.row.IsShop"
              icon="el-icon-plus"
              size="small"
              @click="handleCreate(scope.row)"
              >添加</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <!--新增框 -->
    <div v-if="formVisible">
      <el-dialog
        v-dragDialog
        :title="formTitle"
        :visible.sync="formVisible"
        width="800px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="formData"
          ref="formData"
          label-width="150px"
          :rules="formRules"
        >
          <el-form-item
            label="类型："
            v-if="formData.Key != tenantKey"
            prop="IsShop"
          >
            <el-switch
              inactive-text="管理机构"
              active-text="店铺"
              v-model="formData.IsShop"
            ></el-switch>
          </el-form-item>
          <el-form-item label="店铺代码：" prop="Code">
            <el-input
              v-model="formData.Code"
              auto-complete="off"
              placeholder="请输入自定义店铺编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺名称：" prop="Name">
            <el-input
              v-model="formData.Name"
              auto-complete="off"
              placeholder="请输入在美团平台上的店铺名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="平台扣费："
            v-if="formData.IsShop"
            prop="PlatChargeRate"
          >
            <el-input-number
              size="small"
              v-model="formData.PlatChargeRate"
              auto-complete="off"
            ></el-input-number
            >%
          </el-form-item>
          <el-form-item label="负责人：" prop="Responser">
            <el-input
              v-model="formData.Responser"
              auto-complete="off"
              placeholder="请输入负责人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="Mobile">
            <el-input
              v-model="formData.Mobile"
              auto-complete="off"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址：" prop="Address">
            <el-input
              v-model="formData.Address"
              auto-complete="off"
              placeholder="请输入联系地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="Email">
            <el-input
              v-model="formData.Email"
              auto-complete="off"
              placeholder="请输入邮件地址,多邮件用/分隔"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="formData.IsShop"
            label="DeveloperId:"
            prop="DeveloperId"
          >
            <el-input
              v-model="formData.DeveloperId"
              auto-complete="off"
              placeholder="请输入DeveloperId"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="formData.IsShop" label="SignKey:" prop="SignKey">
            <el-input
              v-model="formData.SignKey"
              auto-complete="off"
              placeholder="请输入SignKey"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="formData.IsShop" label="AppKey：" prop="AppKey">
            <el-input
              v-model="formData.AppKey"
              auto-complete="off"
              placeholder="请输入AppKey"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="formData.IsShop" label="AppSecret：" prop="AppSecret">
            <el-input
              v-model="formData.AppSecret"
              auto-complete="off"
              placeholder="请输入AppSecret"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="formData.IsShop" label="RedirectUrl：" prop="RedirectUrl">
            <el-input
              v-model="formData.RedirectUrl"
              auto-complete="off"
              placeholder="请输入RedirectUrl"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item v-if="formData.IsShop" label="OpenShopUuid：" prop="OpenShopUuid">
            <el-input
              v-model="formData.OpenShopUuid"
              auto-complete="off"
              placeholder="请输入OpenShopUuid"
            ></el-input>
          </el-form-item> -->
          <el-form-item v-if="formData.IsShop" label="Token：" prop="Token">
            <el-input
              v-model="formData.Token"
              auto-complete="off"
              placeholder="请输入Token"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="formData.IsShop"
            label="RefreshToken："
            prop="RefreshToken"
          >
            <el-input
              v-model="formData.RefreshToken"
              auto-complete="off"
              placeholder="请输入RefreshToken"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="Description">
            <el-input
              v-model="formData.Description"
              auto-complete="off"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { save, getTree, refreshToken, del } from "@/api/setting/tenant";
import { syncOrders } from "@/api/bussiness/order";
export default {
  components: {},
  data() {
    return {
      tenantKey: localStorage.getItem("X-TenantKey"),
      total: 0,
      tenantData: [],
      formTitle: "",
      formVisible: false,
      formData: {},
      formRules: {
        DeveloperId: [
          {
            required: true,
            message: "请输入美团DeveloperId",
            trigger: "change",
          },
        ],
        SignKey: [
          { required: true, message: "请输入美团SignKey", trigger: "change" },
        ],
        // AppKey: [
        //   { required: true, message: "请输入北极星AppKey", trigger: "change" },
        // ],
        // AppSecret: [
        //   { required: true, message: "请输入北极星秘钥", trigger: "change" },
        // ],
        // RedirectUrl: [
        //   {
        //     required: true,
        //     message: "请输入北极星回调地址",
        //     trigger: "change",
        //   },
        // ],
        Code: [
          { required: true, message: "请输入店铺编号", trigger: "change" },
        ],
        Name: [
          { required: true, message: "请输入店铺名称", trigger: "change" },
        ],
        Responser: [
          { required: true, message: "请输入负责人", trigger: "change" },
        ],
        Address: [
          { required: true, message: "请输入联系地址", trigger: "change" },
        ],
        Email: [
          { required: true, message: "请输入通知邮件地址", trigger: "change" },
        ],
        Mobile: [
          { required: true, message: "请输入联系电话", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    loadPageData() {
      let data = {};
      getTree(data).then((response) => {
        if (response) {
          this.tenantData = response;
        }
      });
    },
    handleCreate(parent) {
      this.formVisible = true;
      this.formTitle = "新增";
      this.formData = {
        Key: "",
        Parent: { Key: "" },
        DeveloperId: "",
        SignKey:"",
        // APPKey: "",
        // AppSecret: "",
        RedirectUrl: "",
        Code: "",
        Name: "",
        Responser: "",
        Mobile: "",
        Address: "",
        Email: "",
        Description: "",
      };
      if (parent) {
        this.formData.Parent.Key = parent.Key;
      } else {
        this.formData.Parent = null;
      }
    },
    handleAuth(row) {
      let url = `https://open-erp.meituan.com/general/auth?developerId=${row.AppKey}&state=${row.Code}&redirect_url=https://meijia.codetime.com.cn/auth.html`;
      window.open(url);
    },
    handleRefresh(row) {
      this.$confirm("确认刷新token吗？", "提示", {}).then(() => {
        let parma = { key: row.Key };
        refreshToken(parma).then(res);
        {
          if (res) {
            this.loadPageData();
          }
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        del(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.loadPageData();
          }
        });
      });
    },
    handleUpdate(data) {
      this.formData = Object.assign({}, data);
      if (!data.TokenExpire || !data.IsShop) {
        this.formData.TokenExpire = null;
      }
      this.formTitle = "修改";
      this.formVisible = true;
    },
    handleSubmit: function () {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        let data = Object.assign({}, this.formData);
        if (!data.IsShop) {
          data.TokenExpire = null;
        }
        save(data).then((response) => {
          if (response) {
            this.formVisible = false;
            this.loadPageData();
          }
        });
      });
    },
  },
  mounted() {
    this.loadPageData();
  },
};
</script>
<style  lang='scss' scoped>
.page-container {
  height: 100%;
}

/deep/.el-tree-node__content {
  height: 40px !important;
  box-sizing: border-box;
}
/deep/.el-form-item__content {
  line-height: 20px;
}
/deep/.el-form-item__label {
  line-height: 20px;
}
.node-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .type {
      margin-right: 10px;
    }
  }
}

.left-box {
  /deep/.el-card__body {
    height: calc(100% - 55px);
    padding: 20px;
    box-sizing: border-box;
  }
}

.right-box {
  /deep/.el-card__body {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
}

/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-top: 5px;
  margin: 10px;
  padding-bottom: 5px;
  padding-right: 8px;
}

/deep/.el-tree-node__content {
  display: flex;
  align-items: center;
  height: 0.155417rem;
  line-height: 42px;
  cursor: pointer;
}

/deep/.el-radio__input {
  line-height: 40px;
}
</style>